import React from 'react'
import LineItemInput from './LineItemInput'
import { Box, Divider, Grid, IconButton } from '@mui/material'

import { makeStyles } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { itemPriceOptionsObj } from '../../../lib/Constants'

const useStyles = makeStyles(theme => ({
  singleLineItemContainer: {
    marginBottom: '20px'
  },
  dividerContainer: {
    width: '1px',
    justifyContent: 'center',
    display: 'flex'
  },
  divider: {
    backgroundColor: theme.colors.grey,
    width: '0.2px'
  },
  iconStyle: {
    fontSize: '14px',
    color: theme.colors.grey
  },
  description: {
    '& .MuiInputBase-root': {
      height: '50px',
      backgroundColor: theme.colors.grey_2,
      fontSize: '14px'
    }
  },
  titleSpace: {
    height: '10px'
  }
}))

function SingleMaterialPart({
  item,
  index,
  onChange,
  onRemove,
  disabled,
  hideRightAction,
  question
}) {
  const enableAmounts =
    question?.item_price ===
    itemPriceOptionsObj.ENABLE_ITEM_PRICE_TAX_TOTAL_PRICE
  const { t } = useTranslation()
  const classes = useStyles()

  const RightAction = () => {
    if (!hideRightAction) {
      return (
        <IconButton
          aria-label="delete"
          onClick={() => onRemove(index)}
          disabled={disabled}
        >
          <FontAwesomeIcon
            icon="fa-sharp fa-regular fa-circle-xmark"
            className={classes.iconStyle}
          />
        </IconButton>
      )
    }
    return null
  }
  return (
    <Box className={classes.singleLineItemContainer}>
      <LineItemInput
        hideRightAction={hideRightAction}
        required={true}
        placeholder={t('work_orders.line_item.enter_name')}
        label={t('work_orders.line_item.material') + ` ${index + 1}`}
        onChange={e => onChange(index, 'name', e.target.value)}
        value={item.name}
        disabled={disabled}
        rightAction={!disabled && <RightAction />}
      />
      <LineItemInput
        textAreaAutosize={true}
        customClasses={classes.description}
        multiline={true}
        disabled={disabled}
        placeholder={t('work_orders.line_item.enter_description')}
        label={t('work_orders.line_item.item_description')}
        onChange={e => onChange(index, 'description', e.target.value)}
        value={item.description}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flex: 3 }}>
          <LineItemInput
            disabled={disabled}
            placeholder={`${t('work_orders.line_item.item')} #`}
            label={`${t('work_orders.line_item.item')} #`}
            onChange={e => onChange(index, 'number', e.target.value)}
            value={item.number}
          />
        </Box>
        <Box sx={{ width: '20px', justifyContent: 'center', display: 'flex' }}>
          <Divider orientation="vertical" className={classes.divider} />
        </Box>
        <Box sx={{ display: 'flex', flex: 1.33 }}>
          <LineItemInput
            disabled={disabled}
            required={true}
            placeholder={t('work_orders.line_item.quantity')}
            label={t('work_orders.line_item.qty')}
            onChange={e => onChange(index, 'quantity', e.target.value)}
            value={item.quantity}
          />
        </Box>
      </Box>
      {enableAmounts && (
        <Grid container sx={{ marginTop: '10px' }}>
          <Grid item xs>
            <LineItemInput
              disabled={disabled}
              placeholder={`${t('work_orders.line_item.per_item_price')}`}
              label={`${t('work_orders.line_item.price')}`}
              onChange={e => onChange(index, 'price', e.target.value)}
              value={item.price}
            />
          </Grid>
          <Grid item xs={1} className={classes.dividerContainer}>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs>
            <LineItemInput
              disabled={disabled}
              placeholder={`${t('work_orders.line_item.tax')} (%)`}
              label={`${t('work_orders.line_item.tax')} %`}
              onChange={e => onChange(index, 'tax', e.target.value)}
              value={item.tax}
            />
          </Grid>
          <Grid item xs={1} className={classes.dividerContainer}>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs>
            <LineItemInput
              disabled={true} // always disabled
              placeholder={'0.00'}
              label={`${t('work_orders.line_item.total_price')}`}
              onChange={e => onChange(index, 'total_price', e.target.value)}
              value={item.total_price}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  )
}

export default SingleMaterialPart
